import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, FormGroupDirective, NgForm} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {InviteV2} from 'src/app/models/invite-v2';
import {CryptoService} from 'src/app/services/crypto.service';
import {AngularFireStorage} from '@angular/fire/compat/storage';;
import {MemberTempService} from 'src/app/services/member-temp.service';

import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import {SnackBarIconService} from 'src/app/shared/snack-bar-icon/snack-bar-icon.service';
import {ErrorStateMatcher} from '@angular/material/core';
import {InviteSpeakersService} from 'src/app/services/invite-speakers.service';

/** Error when invalid control is dirty, touched, or submitted. */
export class FormErrorStateMatcher implements ErrorStateMatcher {
  isErrorState (control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
  selector: 'app-speaker-update-data',
  templateUrl: './speaker-update-data.component.html',
  styleUrls: [ './speaker-update-data.component.scss' ]
})
export class SpeakerUpdateDataComponent implements OnInit {

  public matcher = new FormErrorStateMatcher();

  public param: any;
  public member_id: any;
  public letter_id: any;
  public event_id: any;
  public redirect: boolean;

  public invite: InviteV2;
  public welcome: any
  public entityForm: FormGroup;
  public sex: any;
  public title: any;

  public fired: boolean = false;

  public dataUpdated: boolean = false;

  public spinner: boolean;
  public readyToShow: boolean;

  public Editor = ClassicEditor;

  public show_name: string;
  public show_email: string;
  public show_cellPhone: string;
  public show_cpf: string;

  constructor (
    private fs: AngularFireStorage,
    private _cryptoService: CryptoService,
    public _memberTempService: MemberTempService,
    private _activateRoute: ActivatedRoute,
    private _router: Router,
    private _inviteSpeakerService: InviteSpeakersService,
    private fb: FormBuilder,
    private snackBar: SnackBarIconService
  ) {
    /*
    this.param = this._activateRoute.snapshot.paramMap.get('uid');
    const params = this.param.split(":")

    this.member_uid = params[ 0 ] as string;
    this.letter_uid = params[ 1 ] as string;
    this.event_uid = params[ 2 ] as string;
    this.redirect = params[ 3 ] as boolean;

    this._inviteSpeakerService.selectByInvite(this.member_uid, this.letter_uid, this.event_uid)
      .subscribe((result) => {
        result.forEach(element => {
          this.invite = new InviteV2();
          this.invite.id = element.id;
          this.invite.event_name = element.data().event_name
          this.invite.member_id = element.data().member_id
          this.invite.member_name = element.data().member_name
          this.invite.member_email = element.data().member_email
          this.invite.agenda = element.data().agenda

          this.invite.accept = element.data().accept ? element.data().accept : false;
          this.invite.date_response = element.data().date_response ? element.data().date_response : null;
          this.invite.memberDataCheck = element.data().memberDataCheck ? element.data().memberDataCheck : ''

        });

        console.log("this.invite.date_response: " + this.invite.date_response)

        this.show_name = this.invite.memberDataCheck.name
        this.show_email = this._cryptoService.get(this._cryptoService.key, this.invite.memberDataCheck.email)
        this.show_cellPhone = this._cryptoService.get(this._cryptoService.key, this.invite.memberDataCheck.cellPhone)
        this.show_cpf = this._cryptoService.get(this._cryptoService.key, this.invite.memberDataCheck.cpf)

        this.entityForm = this.createForm();

        this.readyToShow = true;
      })
        */

  }

  ngOnInit () {
    this._activateRoute.params.subscribe(data => {
      const param = data[ 'uid' ];
      const params = param.split(":")

      this.member_id = params[ 0 ] as string;
      this.letter_id = params[ 1 ] as string;
      this.event_id = params[ 2 ] as string;
      this.redirect = params[ 3 ] as boolean;

      this.selectByInvite(this.member_id, this.letter_id, this.event_id);

    })
  }

  selectByInvite (member_id: any, letter_id: any, context_id: any) {
    this._inviteSpeakerService.selectByInvite(member_id, letter_id, context_id)
      .subscribe((result) => {
        result.forEach(element => {
          this.invite = new InviteV2();
          this.invite.id = element.id;
          this.invite.event_id = element.data().event_id
          this.invite.event_name = element.data().event_name
          this.invite.context_id = element.data().context_id
          this.invite.member_id = element.data().member_id
          this.invite.member_name = element.data().member_name
          this.invite.member_email = element.data().member_email
          this.invite.agenda = element.data().agenda

          ///////////////////////////////////
          this.invite.accept = element.data().accept ? element.data().accept : false;
          this.invite.date_response = element.data().date_response ? element.data().date_response : null;
          this.invite.memberDataCheck = element.data().memberDataCheck ? element.data().memberDataCheck : ''

        });

        console.log("this.invite.date_response: " + this.invite.date_response)

        this.show_name = this.invite.memberDataCheck.name
        this.show_email = this._cryptoService.get(this._cryptoService.key, this.invite.memberDataCheck.email)
        this.show_cellPhone = this._cryptoService.get(this._cryptoService.key, this.invite.memberDataCheck.cellPhone)
        this.show_cpf = this._cryptoService.get(this._cryptoService.key, this.invite.memberDataCheck.cpf)

        this.entityForm = this.createForm();

        this.readyToShow = true;
      })
  }

  createForm () {
    // const plain_email = this._cryptoService.get(this._cryptoService.key, this.invite.member_email)
    this._memberTempService.storedImage = this.invite.memberDataCheck.image

    let form: FormGroup = this.fb.group({
      // name: new FormControl(this.invite.memberDataCheck.name),
      image: new FormControl(this.invite.memberDataCheck.image),
      text: new FormControl(this.invite.memberDataCheck.text),
      comments: new FormControl(''),
    });
    return form
  }

  updateChanges () {

    let dataToUpdate: any = {
      'name': this.show_name,
      'changed': false,
      'dateCreated': new Date(),
      'imageChanged': false,
      'moved': false,
      'text': this.entityForm.controls.text.value,
      'comments': this.entityForm.controls.comments.value,
      'updated': true
    }

    if (this._memberTempService.objectImage) {
      this._memberTempService.uploadImage(this._memberTempService.objectImage, this.member_id)
        .subscribe((result: any) => {
          result.ref.getDownloadURL()
            .then((url) => {

              dataToUpdate.image = url
              dataToUpdate.changed = true
              dataToUpdate.imageChanged = true

              this.updateData(this.member_id, dataToUpdate)

            })
        })
    } else {
      const textBefore: string = this.invite.memberDataCheck.text
      const textAfter: string = this.entityForm.controls.text.value
      const comments: string = this.entityForm.controls.comments.value

      if ((textBefore != textAfter) || comments.length > 0) {
        dataToUpdate.changed = true
      } else {
        dataToUpdate.changed = false
      }

      dataToUpdate.updated = true

      //  console.log("dataToUpdate: " + JSON.stringify(dataToUpdate))

      this.updateData(this.member_id, dataToUpdate)
    }

  }

  byPassUpdateChanges(){
    this._router.navigate([ 'speaker-end-back' ]);
  }

  updateData (id: string, data: any) {

    this._memberTempService.update(id, data)
      .then(() => {
        this.snackBar.openSnackBar("Sucesso!", '', 'success')
        this._router.navigate([ 'speaker-end-back' ]);
      })
      .catch((err) => {
        console.log("Erro! updateData: " + err.message)
        this.snackBar.openSnackBar("Erro! xxxxx", '', 'error')
      })

  }

}
